import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';

const today = new Date().toLocaleDateString('en-CA');

interface ICsvModalProps {
  open: boolean;
  isLoading: boolean;
  onClose: () => void;
  onGenerate: (startDate: string, endDate: string) => Promise<void>;
}

const DownloadOrdersModal = ({
  open,
  isLoading,
  onClose,
  onGenerate,
}: ICsvModalProps) => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    if (!open) {
      setStartDate('');
      setEndDate('');
    }
  }, [open]);

  const handleGenerate = async () => {
    await onGenerate(startDate, endDate);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        Descargar csv
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 4 }}>
          Se descargará un archivo <b>.csv</b> con la información de las órdenes
          que se encuentren dentro del rango de fechas seleccionado y los
          filtros aplicados a la tabla:
        </Typography>
        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            type="date"
            label="Fecha inicio"
            size="small"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            slotProps={{
              inputLabel: { shrink: true },
              htmlInput: { max: today },
            }}
            required
            fullWidth
          />
          <TextField
            type="date"
            label="Fecha fin"
            size="small"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            slotProps={{
              inputLabel: { shrink: true },
              htmlInput: { min: startDate, max: today },
            }}
            required
            fullWidth
          />
          <Button
            variant="contained"
            color="info"
            sx={{ mt: 1 }}
            onClick={handleGenerate}
            disabled={
              isLoading ||
              !startDate ||
              !endDate ||
              endDate < startDate ||
              endDate > today
            }
            startIcon={<DownloadIcon />}
            fullWidth
          >
            Generar
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DownloadOrdersModal;
